export default __webpack_public_path__ + "static/media/Exclamation-mark-red-icon.00aa36fe.svg";